import type { TableColumnConfig, TableColumnWidths } from '@ipfabric/utils';
import { TABLE_COLUMN_DEFAULT_WIDTH } from 'components/Table/tableSettings';

export const getColumnDefaultWidth = (
  columnConfig: TableColumnConfig,
): number => columnConfig.width ?? TABLE_COLUMN_DEFAULT_WIDTH;

export const getColumnWidth =
  (columnWidth: TableColumnWidths | undefined) =>
  (columnConfig: TableColumnConfig): number => {
    if (columnConfig.fixedWidth) {
      // ignore custom setting (probably obsolete data in user settings) when column has fixed width
      return getColumnDefaultWidth(columnConfig);
    }

    return (
      columnWidth?.[columnConfig.key] ?? getColumnDefaultWidth(columnConfig)
    );
  };
